import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
    imports: [
        CommonModule
    ],
    selector: 'route-not-found',
    styleUrls: ['./not-found.component.scss'],
    templateUrl: './not-found.component.html'
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
